<template>
    <div>
        <h2 v-if="plan != null">
            {{ plan.name }} Plan
            <button class="btn btn-sm btn-outline-danger" @click="changePlan">
                Change Plan
            </button>
        </h2>

        <div v-if="customer != null" class="row quotas">
            <div class="col-sm-8 text-center">
                <div class="card quota">
                    <div class="card-header text-white bg-dark">
                        Monthly Quota
                    </div>
                    <div class="card-body">
                        <div class="card-title progress">
                            <div
                                :style="'width: ' + usagePercent + '%'"
                                :aria-valuenow="usagePercent"
                                class="progress-bar progress-bar-striped progress-bar-animated bg-dark"
                                role="progressbar"
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                {{ usagePercent }}%
                            </div>
                        </div>
                        <p class="card-text">
                            {{ prettyBytes(customer.usage) }} /
                            {{ prettyBytes(customer.quota) }}
                        </p>
                    </div>
                    <div class="card-footer">
                        <small class="text-muted">Renew {{ period_end }}</small>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 text-center">
                <div class="card quota">
                    <div class="card-header text-white bg-secondary">
                        Additional Quota
                    </div>
                    <div class="card-body">
                        <h4 class="card-text">
                            {{ prettyBytes(additional_quota) }}
                        </h4>
                    </div>
                    <div class="card-footer">
                        <small class="text-muted"
                            >Since {{ period_start }}</small
                        >
                    </div>
                </div>
            </div>
        </div>

        <div v-if="customer != null" class="row quotas">
            <div class="col-sm-6 text-center">
                <div class="card quota">
                    <div class="card-header text-white bg-dark">
                        Proxies / IPs
                    </div>
                    <div class="card-body">
                        <div class="card-title progress">
                            <div
                                :style="
                                    'width: ' +
                                        (customer.account_count * 100) /
                                            customer.account_max +
                                        '%'
                                "
                                :aria-valuenow="customer.account_count"
                                :aria-valuemax="customer.account_max"
                                aria-valuemin="0"
                                role="progressbar"
                                class="progress-bar progress-bar-striped progress-bar-animated bg-dark"
                            >
                                {{ customer.account_count }}
                            </div>
                        </div>
                        <p class="card-text">
                            {{ customer.account_count }} /
                            {{ customer.account_max }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'
import prettyBytes from 'pretty-bytes'
import moment from 'moment'

import { config, auth, response } from 'website-core'

export default {
    data() {
        return {
            customer: null,
            additional_quota: 0,
            period_start: '',
            period_end: '',

            plan: null,
        }
    },
    computed: {
        usagePercent() {
            return Math.round((this.customer.usage * 100) / this.customer.quota)
        },
    },
    created() {
        this.getCustomer()
    },
    methods: {
        getCustomer() {
            var self = this

            superagent
                .get(config.url_api + '/customer')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.customer = res.body

                    // get period
                    for (var key in self.customer.gateway) {
                        self.period_start = moment(
                            self.customer.gateway[key].sub.period_start
                        ).fromNow()
                        self.period_end = moment(
                            self.customer.gateway[key].sub.period_end
                        ).fromNow()
                    }

                    // get additional quota
                    var additional_quota =
                        self.customer.usage - self.customer.quota
                    self.additional_quota =
                        additional_quota > 0 ? additional_quota : 0

                    // get plan
                    self.getPlan(self.customer.plan)

                    return
                })
        },
        getPlan(id) {
            var self = this

            superagent
                .get(config.url_api + '/plan/' + id)
                .end(function(err, res) {
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.plan = res.body
                    return
                })
        },
        changePlan() {
            this.$router.push('/billing')
        },
        prettyBytes(bytes) {
            return prettyBytes(bytes)
        },
    },
}
</script>

<style scoped>
.quotas {
    margin: 1rem 0;
}
.quota {
    margin: 0.5rem 0;
}
</style>
